import { clientConfigurationUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { GatewayCleanupResponse } from "@src/types/namespace-configuration";
import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";

export const cleanupGateway = async (
  namespace: string,
  gatewayId: string,
): Promise<GatewayCleanupResponse> => {
  const url = clientConfigurationUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.delete<GatewayCleanupResponse>(
      `${url}/internal/api/v3/ns/${namespace}/onboarding/cleanup`,
      {
        headers,
        params: {
          gateway_id: gatewayId,
        },
      },
    );

    return response.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw new Error(
        err.response?.data?.detail ||
          err.response?.data?.message ||
          `Failed to clean up gateway${
            err.response?.status ? ` (HTTP ${err.response.status})` : ""
          }. Please try again later.`,
      );
    }

    throw new Error(
      "An unexpected error occurred while cleaning up the gateway.",
    );
  }
};
